export default class {
  constructor() {
    this.init()
  }

  init() {
    window.addEventListener('click', this.disabledInteractive)
    window.addEventListener('contextmenu', this.disabledInteractive)
    window.addEventListener('mousedown', this.disabledInteractive)
    window.addEventListener('copy', this.copyImageGuard)
    document.addEventListener('selectstart', this.onSelectstart.bind(this))
    document.addEventListener('selectionchange', this.cancelRangeSelectWithDisabledImg)
  }

  destroy() {
    window.removeEventListener('click', this.disabledInteractive)
    window.removeEventListener('contextmenu', this.disabledInteractive)
    window.removeEventListener('mousedown', this.disabledInteractive)
    window.removeEventListener('copy', this.copyImageGuard)
    document.removeEventListener('selectstart', this.onSelectstart.bind(this))
    document.removeEventListener('selectionchange', this.cancelRangeSelectWithDisabledImg)
  }

  disabledInteractive(e) {
    const target = e.target.hasAttribute('data-disabled-interactive') ? e.target : e.target.closest('[data-disabled-interactive]')

    if (!target) {
      return
    }

    e.preventDefault()
  }

  onSelectstart(e) {
    this.selectImageGuard(e)
    this.cancelRangeSelectWithDisabledImg()
  }

  selectImageGuard(e) {
    if (e?.target instanceof HTMLElement && e?.target?.hasAttribute('data-disabled-interactive')) {
      e.preventDefault()
    }
  }

  copyImageGuard(e) {
    const selection = window.getSelection()

    if (!selection?.rangeCount) {
      return
    }

    const range = selection.getRangeAt(0).cloneContents()

    const guardImages = range.querySelectorAll('[data-disabled-interactive]')
    guardImages.forEach(img => img.remove())

    if (range.childNodes.length > 0) {
      e.preventDefault()
      const tempDiv = document.createElement('div')
      tempDiv.appendChild(range)

      e.clipboardData.setData('text/html', tempDiv.innerHTML)
      e.clipboardData.setData('text/plain', tempDiv.textContent)
    }
  }

  cancelRangeSelectWithDisabledImg() {
    const selection = window.getSelection();

    if (!selection?.rangeCount) {
      return
    }

    const selectedNodes = selection?.getRangeAt(0)?.cloneContents()?.querySelectorAll('[data-disabled-interactive]');

    if (!selectedNodes?.length) {
      return
    }

    const range = selection?.getRangeAt(0);
    const newRange = document.createRange();

    newRange.setStart(range.startContainer, range.startOffset);
    newRange.setEnd(range.startContainer, range.startOffset);

    selection.removeAllRanges();
    selection.addRange(newRange);
  }
}
